import { render, staticRenderFns } from "./order-add-or-update.vue?vue&type=template&id=18a20d41&scoped=true&"
import script from "./order-add-or-update.vue?vue&type=script&lang=js&"
export * from "./order-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./order-add-or-update.vue?vue&type=style&index=0&id=18a20d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a20d41",
  null
  
)

export default component.exports